module.exports = __webpack_public_path__ + "img/international-domestic.685bf47b.jpg";